var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkTransferIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: " ease-in-out text-current stroke-current",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6727 1.94687L12.606 3.69354C13.7394 4.19354 13.7394 5.02021 12.606 5.52021L8.6727 7.26687C8.22603 7.46687 7.4927 7.46687 7.04603 7.26687L3.1127 5.52021C1.97936 5.02021 1.97936 4.19354 3.1127 3.69354L7.04603 1.94687C7.4927 1.74688 8.22603 1.74688 8.6727 1.94687Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.33398C2 7.89398 2.42 8.54065 2.93333 8.76732L7.46 10.7807C7.80667 10.934 8.2 10.934 8.54 10.7807L13.0667 8.76732C13.58 8.54065 14 7.89398 14 7.33398",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.666C2 11.286 2.36667 11.846 2.93333 12.0993L7.46 14.1127C7.80667 14.266 8.2 14.266 8.54 14.1127L13.0667 12.0993C13.6333 11.846 14 11.286 14 10.666",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkTransferIcon);
export default __webpack_public_path__ + "static/media/BulkTransferIcon.24bcdd6c.svg";
export { ForwardRef as ReactComponent };